import { INativeMidiDevice } from "../services/eventBus/nativeApp/FromNativeAppEventTypes";
import { IMidiInput } from "./IMidiInput";

/**
 * NativeMidiInput represents a MIDI input device from the native iOS MIDIKit bridge.
 * This mirrors the interface of NormalizedMidiInput for WebMIDI, allowing both to be
 * used interchangeably in the MIDI event system.
 */
export class NativeMidiInput implements IMidiInput {
  private readonly device: INativeMidiDevice;

  constructor(device: INativeMidiDevice) {
    this.device = device;
  }

  /**
   * Get the unique identifier for this MIDI input.
   * For native inputs, this is a numeric ID from MIDIKit.
   */
  public getId(): string {
    return this.device.id.toString();
  }

  /**
   * Get the display name of this MIDI input device.
   */
  public getName(): string {
    return this.device.name;
  }

  public toString(): string {
    return `{ id: ${this.device.id}, name: ${this.device.name}, manufacturer: ${this.device.manufacturer} }`;
  }
}
